import React, { Fragment } from "react";
import WarningIcon from "./WarningIcon";
import NotificationIcon from "./NotificationIcon";
import TableSection from "./TableSection";
import Chat from "./Chat";
import { getAllApartments, hideNotification } from "../reducers/apartments";
import { connect } from "react-redux";
import Bilancio from "./Bilancio";

const style = {
  height: 64,
  width: 64,
  objectFit: "fill",
  marginTop: 4,
  cursor: "pointer",
};

class ApartmentButton extends React.Component {
  showInnerComponent = (component) => {
    // console.log(component);
    if (component === "bilancio")
      return (
        <Bilancio
          servizi={this.props.apartmentData.servizi}
          versamenti={this.props.apartmentData.versamenti}
          apartmentName={this.props.apartmentName}
        />
      );
    else if (component == "chat")
      return (
        <Chat
          messaggi={this.props.messaggi}
          apartmentName={this.props.apartmentName}
        />
      );
    else if (component == null) return null;
    else
      return (
        <TableSection
          scope={this.props.serviceId}
          // servizi={this.props.servizi}
          apartmentName={this.props.apartmentName}
        />
      );
  };
  setMenu = () => {
    this.props.setMenu(this.props.serviceId);
  };

  render() {
    const buttonStyle = {
      // position:"relative",
      border: "none",
      height:
        this.props.show == this.props.buttonName ? "calc(6vh + 4px)" : "6vh",
      width: window.innerWidth / (this.props.numberOfButtons + 2),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor:
        this.props.show == this.props.buttonName ? "#FFE533" : "#FFEF85",
      color: "#645B40",
      boxShadow: "2px 2px 2px 0px rgba(0,0,0,0.4)",
      marginLeft: 6,
      marginRight: 6,
      marginBottom: 0,
      marginTop: 0,
      cursor: "pointer",
      // zIndex: this.props.show == this.props.buttonName ? 0 : 0,
      outline: 0,
      fontSize: 16,
    };

    return (
      <Fragment>
        <div style={{ position: "relative" }}>
          <button
            type={"button"}
            style={buttonStyle}
            onClick={() => this.setMenu()}
          >
            {this.props.buttonName}
          </button>
          {this.props.buttonName !== this.props.show && (
            <Fragment>
              {this.props.buttonName == "chat" &&
                !!this.props.notificationButton && (
                  <div style={{ position: "absolute", top: 0, right: 0 }}>
                    <Fragment>
                      <NotificationIcon
                        size={this.props.size}
                        notification={this.props.notificationButton}
                      />
                    </Fragment>
                  </div>
                )}

              {this.props.buttonName !== "chat" && !!this.props.warningButton && (
                <div style={{ position: "absolute", top: 0, right: 0 }}>
                  <WarningIcon
                    size={this.props.size}
                    warning={this.props.warningButton}
                  />
                </div>
              )}
            </Fragment>
          )}
        </div>
        {this.props.show == this.props.serviceId && (
          <div
            style={{
              position: "absolute",
              marginTop:
                this.props.show == this.props.serviceId
                  ? "calc(6vh + 4px)"
                  : "6vh",
              zIndex: 400,
            }}
          >
            <div
              className={"hideScrollBar"}
              style={{
                backgroundColor: "#ffe533",
                width: `calc(${this.props.numberOfButtons} * 9vw + ${this.props.numberOfButtons} * 7px + ${this.props.numberOfButtons} * 7px`,
                minWidth: "83vw",
                height: "76vh",
                marginLeft: 0,
                overflowY: "scroll",
              }}
            >
              <div>{this.showInnerComponent(this.props.serviceId)}</div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  apartments: state.apartments.data,
  apartment: state.apartments.singleApartment.data,
  loading: state.apartments.loading,
  error: state.apartments.error,
});

const mapDispatchToProps = (dispatch) => {
  return {
    hideNotification: (apartmentName) =>
      dispatch(hideNotification(apartmentName)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApartmentButton);
